import { Navigate, useParams } from 'react-router-dom';
import { Panel, Spinner } from '@epam/promo';
import { useTaskStore } from 'store/task.store';
import { useTaskGetQuery } from 'hooks';
import { FormHeader } from 'components/tasks/FormHeader';
import css from './TaskForm.module.scss';
import { FormBody } from '../FormBody';

export const TaskForm = () => {
  const params = useParams<{ taskId: string }>();
  const draftTask = useTaskStore((state) => state.draft);
  const { isLoading, isError } = useTaskGetQuery(params.taskId ?? '');

  if (isLoading) {
    return <Spinner color="blue" />;
  }

  if (isError) {
    return <Navigate to="/tasks" />;
  }

  return (
    <Panel shadow cx={css.page__container}>
      <FormHeader />
      <FormBody task={draftTask} />
    </Panel>
  );
};
